import { render, staticRenderFns } from "./GuiaRemision.vue?vue&type=template&id=ef6c7bfc&scoped=true&"
import script from "./GuiaRemision.vue?vue&type=script&lang=js&"
export * from "./GuiaRemision.vue?vue&type=script&lang=js&"
import style0 from "./GuiaRemision.vue?vue&type=style&index=0&id=ef6c7bfc&lang=scss&scoped=true&"
import style1 from "./GuiaRemision.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./GuiaRemision.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6c7bfc",
  null
  
)

export default component.exports